import React from 'react';
import { Col } from 'react-bootstrap';
import NoRecord from 'assets/img/search/no-record.svg';
import NoRecordDark from 'assets/img/search/no-record-dark.svg';

function SearchCandidateFallback() {
  return (
    <Col xs={12}>
      <div className="d-flex flex-column align-items-center">
        <img src={NoRecord} className="d-dark-none" height={200} />
        <img src={NoRecordDark} className="d-light-none" height={200} />
        <h3 className="mb-3">Smart Candidate Search</h3>
        <p className="text-center">
          Effortlessly find the right candidate by simply typing their keywords
          into the search bar. <br /> Streamline your search process and connect
          with the perfect match in seconds!
        </p>
      </div>
    </Col>
  );
}

export default SearchCandidateFallback;
